import axios from "axios";
import { CustomerSearchFilters } from "../../types";

// PATHS
const RA_CHECK_OUT_IN = '/network/ra/';
const RA_CHECK_UPDATE_VEHICLE_STATUS = '/network/vehicle-mng/vehiclestatus/';
const CHECK_OUT_IN_DAMAGES = '/network/vehicle-mng/getCheckOutInDamagesByTenantAndVinOrPlate';
const CHECK_OUT_IN_KEYBOX = '/network/ms/check-keybox-service';
const CHECK_OUT_IN_CREATE_DAMAGE = '/network/vehicle-mng/createOpen';
const CHECK_OUT_IN_EDIT_DAMAGE = '/network/vehicle-mng/editOpen';
const CHECK_OUT_IN_UPDATE_COUNTERPARTY_DATA = '/network/vehicle-mng/updateCounterpartyData';
const CHECK_OUT_IN_ADD_SNAPSHOT = '/network/vehicle-mng/addSnapshots';
const CHECK_OUT_IN_GET_SNAPSHOT_BLOB_BY_ID = '/network/vehicle-mng/getSnapshotBlobById';
const CHECK_OUT_IN_GET_ATTACHMENT_BLOB_BY_ID = '/network/vehicle-mng/getAttachmentBlobById';
const CHECK_OUT_IN_DELETE_ATTACHMENT_BLOB_BY_ID = '/network/vehicle-mng/deleteAttachmentById';
const CHECK_OUT_IN_ADD_ATTACHMENTS = '/network/vehicle-mng/addAttachments';
const CHECK_OUT_IN_CREATE_FORM = '/network/vehicle-mng/createForm';
const CHECK_OUT_IN_CONFIRM_FORM = '/network/vehicle-mng/confirmFormCreation';
const CHECK_OUT_IN_ASYNC_CONFIRM_FORM = '/network/vehicle-mng/asyncConfirmFormCreation';
const CHECK_OUT_IN_DELETE_FORM = '/network/vehicle-mng/deleteDamageForm';
const CHECK_OUT_IN_ASSIGN_DAMAGE_TO_FORM = '/network/vehicle-mng/assignDamagesToForm';
const CHECK_OUT_IN_DELETE_DAMAGE = '/network/vehicle-mng/deleteOpen';
const RA_CHECK_OUT_IN_SEVERITY = '/network/vehicle-mng/getAllSeverity';
const RA_CHECK_OUT_IN_PARTS_AND_POSITIONS = '/network/vehicle-mng/getPartPositionByTenant';
const RA_CHECK_OUT_IN_EVENTS_LIST = '/network/vehicle-mng/getEventByTenant';
const CHECK_OUT_IN_UPDATE_VEHICLE_EQUIPMENTS = '/network/vehicle-mng/vehicleUpdateEquipmentsByPlate';
const CHECK_OUT_IN_CREATE_EQUIPMENTS = '/network/vehicle-mng/addEquipments';
const CHECK_OUT_IN_ASSIGN_EQUIPMENTS = '/network/vehicle-mng/assignEquipmentsToForm';
const RA_CHECK_OUT_IN_ENDPOINT_UPDATE = '/network/ra';
const RA_CHECK_OUT_IN_DAMAGE_PRICE = '/network/vehicle-mng/getDamagesWithPrices';
const RA_CALCULATE_CHECKIN_EXTRA = '/network/pricing/calculate-check-in-extra';
const RA_VEHICLE_IDENTIFICATION_BY_ID_RA = '/network/ra/{id}/checkoutin/{outin}';
const RA_VEHICLE_IDENTIFICATION_BY_PLATE = '/network/ra/raByPlate/{plate}';
const CHECK_OUT_IN_DOWNLOAD_PDF = '/network/ra/downloadPdf/';
const CHECK_OUT_IN_UPLOAD_VEHICLE_ADJUSTMENT_PICS = '/network/adjust/adjustment_pics'
// const CHECK_OUT_IN_CHECKIN_PAYMENT = '/network/payment/checkin';
const FIND_BY_UNIQUE_DATA = '/network/customer/unique-data';
// const CHECK_MS_CLUSTER = '/network/ms/check-msCluster-service';
const CHECK_SUBSTITUTION_CHECK_IN = '/network/search/substitution-by-ra';
const RA_RECOVERY_RECEIPT = '/network/ra/recovery/upload-documents';

const fetchRaCheckOutIn: any = async (req: any): Promise<any> => {
    const response =  await axios.get(RA_CHECK_OUT_IN + req.id);
    return response.data;
    // return new Promise(function (resolve, reject) {
    //
    //         resolve({
    //             data: CHECK_OUT_IN
    //         });
    //         // OR
    //         // reject("Errore")
    //         // OR
    //         // throw new Error("No work for 0");
    //     }
    // );
}

const fetchCheckOutInVehicleStatus: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(RA_CHECK_UPDATE_VEHICLE_STATUS + reqParams.plate + "?tenant=" + reqParams.tenant, reqParams.payload);
    return response.data;
}

const fetchCheckKeyBox: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_KEYBOX, reqParams);
    return response.data;
}

const fetchCheckOutInDamagesByPlate: any = async (reqParams: {tenant: string, plate: string}): Promise<any> => {
    const response = await axios.get(CHECK_OUT_IN_DAMAGES, {params: reqParams});
    return response.data;
}

const fetchCheckOutInCreateDamage: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_CREATE_DAMAGE + "?tenant=" + reqParams.tenant, reqParams.open);
    return response.data;
}

const fetchCheckOutInUpdateCounterpartyData: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_UPDATE_COUNTERPARTY_DATA, reqParams);
    return response.data;
}

const fetchCheckOutInAddSnapshot: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(
        CHECK_OUT_IN_ADD_SNAPSHOT + `?damageId=${reqParams.damageId}&damageIsOpen=${reqParams.damageIsOpen}&idRentalAgreement=${reqParams.idRentalAgreement}`,
        reqParams.snapshots,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
}

const fetchCheckOutInGetSnapshotBlogById: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.get(
        CHECK_OUT_IN_GET_SNAPSHOT_BLOB_BY_ID,
        {params: reqParams}
    );
    return {img: response.data, snapshotId: reqParams.snapshotId};
}

const fetchCheckOutInGetAttachmentBlogById: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.get(
        CHECK_OUT_IN_GET_ATTACHMENT_BLOB_BY_ID,
        {params: reqParams}
    );
    return response.data;
}

const fetchCheckOutInDeleteAttachmentBlogById: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.delete(
        CHECK_OUT_IN_DELETE_ATTACHMENT_BLOB_BY_ID,
        {params: reqParams}
    );
    return response.data;
}

/** Upload events modules CAI/DEN */
const fetchCheckOutInAddAttachments: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(
        CHECK_OUT_IN_ADD_ATTACHMENTS + `?damageFormId=${reqParams.damageFormId}&attachmentTypeId=${reqParams.attachmentTypeId}&documentType=${reqParams.documentType}`,
        reqParams.snapshots,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
}

const fetchCheckOutInDeleteDamage: any = async (reqParams: number): Promise<any> => {
    const response =  await axios.delete(CHECK_OUT_IN_DELETE_DAMAGE + "?damageId=" + reqParams);
    return response.data;
}

const fetchCheckOutInCreateForm: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_CREATE_FORM + "?tenant=" + reqParams.tenant, reqParams.form);
    return response.data;
}

const fetchCheckOutInConfirmForm: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_CONFIRM_FORM + "?tenant=" + reqParams.tenant, reqParams.forms);
    return response.data;
}

const fetchCheckOutInAsyncConfirmForm: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_ASYNC_CONFIRM_FORM + "?tenant=" + reqParams.tenant+ "&plate=" + reqParams.plate, reqParams.forms);
    return response.data;
}

const fetchCheckOutInDeleteForm: any = async (formId: number): Promise<any> => {
    const response =  await axios.delete(CHECK_OUT_IN_DELETE_FORM + "?damageFormId=" + formId);
    return response.data;
}

const fetchCheckOutInAssignDamageToForm: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.put(CHECK_OUT_IN_ASSIGN_DAMAGE_TO_FORM + "?tenant=" + reqParams.tenant, reqParams.damages);
    return response.data;
}

const fetchSeverity: any = async (req: any): Promise<any> => {
    const response = await axios.get(RA_CHECK_OUT_IN_SEVERITY);
    return response.data;
}

const fetchPartsAndPositions: any = async (tenant: any): Promise<any> => {
    const response =  await axios.get(RA_CHECK_OUT_IN_PARTS_AND_POSITIONS, { params: tenant});
    return response.data;
}

const fetchEventsList: any = async (tenant: any): Promise<any> => {
    const response =  await axios.get(RA_CHECK_OUT_IN_EVENTS_LIST, { params: tenant});
    return response.data;
}

/** Eqipments */
const fetchCheckOutInUpdateVehicleEquipments: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_UPDATE_VEHICLE_EQUIPMENTS + `?tenant=${reqParams.tenant}&plate=${reqParams.plate}`, reqParams.body);
    return response.data;
}

const fetchCheckOutInCreateEquipments: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_CREATE_EQUIPMENTS + "?tenant=" + reqParams.tenant, reqParams.equipsList);
    return response.data;
}

const fetchCheckOutInAssignEquipments: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.post(CHECK_OUT_IN_ASSIGN_EQUIPMENTS + "?tenant=" + reqParams.tenant, reqParams.payload);
    return response.data;
}

/** RA Update */
const fetchRaUpdate: any = async (req: any) => {
    const response = await axios.post(RA_CHECK_OUT_IN_ENDPOINT_UPDATE, req);
    return response.data;
}

const fetchRaUpdateCheckInOut: any = async ({ saveSignaturesRequest, language }: { saveSignaturesRequest: any; language: string }) => {
    const response = await axios.post(
        `${RA_CHECK_OUT_IN_ENDPOINT_UPDATE}?language=${language ?? "it"}`, // Aggiungi il parametro language all'URL
        saveSignaturesRequest
    );
    return response.data;
};

// /** CheckIn payment Update */
// const fetchCheckInPayment: any = async (req: any) => {
//     const response = await axios.post(CHECK_OUT_IN_CHECKIN_PAYMENT + `?tenant=${req.tenant}`, req.payload);
//     return response.data;
// }

/** Damage With Price */
const fetchDamagePrice: any = async (payload: any) => {
    const req = '?tenant=' + payload.tenant + '&carClass=' + payload.carClass + '&' + payload.damageFormIds.map((event: number) => `damageFormIds=${event}`).join('&');
    const response = await axios.get(RA_CHECK_OUT_IN_DAMAGE_PRICE + req);
    return response.data;
}

/** Get Extra Km & Extra Days*/
const fetchCheckInExtra: any = async (req: any) => {
    const response = await axios.post(RA_CALCULATE_CHECKIN_EXTRA, req);
    return response.data;
}

/** Get ra by ra id code */
const fetchSearchRaByRaIdCode: any = async (req: any) => {
    const response = await axios.get(RA_VEHICLE_IDENTIFICATION_BY_ID_RA.replace('{id}', req.id).replace('{outin}', req.type) + '?isCheckOutIn=1');
    return response.data;
}

/** Get ra by ra plate */
const fetchSearchRaByPlate: any = async (req: any) => {
    const response = await axios.get(RA_VEHICLE_IDENTIFICATION_BY_PLATE.replace('{plate}', req.plate));
    return response.data;
}

/** Get Doc to sign */
const checkOutInDownloadPdf = async (pdfType: string, idRentalAgreement: string, language: string) => {
    const response = await axios.get(CHECK_OUT_IN_DOWNLOAD_PDF + pdfType, { params: {idRentalAgreement: idRentalAgreement, language: language}, responseType: 'blob'});
    return response.data;
}

const findCustomerBaseByUniqueData = (queryBody: CustomerSearchFilters) => {
    return axios.post(FIND_BY_UNIQUE_DATA, queryBody)
}

// const checkMsCluster: any = async (req: any): Promise<any> => {
//     const response =  await axios.post(CHECK_MS_CLUSTER, req);
//     return response.data;
// }

const checkSubstitutionCheckIn: any = async (reqParams: any): Promise<any> => {
    const response =  await axios.get(CHECK_SUBSTITUTION_CHECK_IN, {params: reqParams});
    return response.data;
}

const recoveryCheckInUploadDoc = async (reqParams: any) => {
    const response = await axios.post(RA_RECOVERY_RECEIPT + `?idRentalAgreement=${reqParams.idRentalAgreement}&type=${reqParams.type}`, reqParams.receipt);
    return response.data;
}

const uploadVehicleAdjustmentPics = async (reqParams: any) => {
    const response = await axios.post(CHECK_OUT_IN_UPLOAD_VEHICLE_ADJUSTMENT_PICS, reqParams);
    return response.data;
}

export const getCustomerBaseById = (id: any) => {
    return axios.get(`/customer/${id}`);
}

export {
    fetchRaCheckOutIn,
    fetchCheckOutInVehicleStatus,
    fetchCheckKeyBox,
    fetchCheckOutInDamagesByPlate,
    fetchCheckOutInCreateDamage,
    fetchCheckOutInConfirmForm,
	fetchCheckOutInAsyncConfirmForm,
    fetchCheckOutInUpdateCounterpartyData,
    fetchCheckOutInDeleteDamage,
    fetchCheckOutInAddSnapshot,
    fetchCheckOutInGetSnapshotBlogById,
    fetchCheckOutInGetAttachmentBlogById,
    fetchCheckOutInDeleteAttachmentBlogById,
    fetchCheckOutInCreateForm,
    fetchCheckOutInDeleteForm,
    fetchCheckOutInAssignDamageToForm,
    fetchCheckOutInAddAttachments,
    fetchSeverity,
    fetchEventsList,
    fetchPartsAndPositions,
    fetchCheckOutInUpdateVehicleEquipments,
    fetchCheckOutInCreateEquipments,
    fetchCheckOutInAssignEquipments,
    fetchRaUpdate,
    fetchDamagePrice,
    // fetchCheckInPayment,
    fetchCheckInExtra,
    fetchSearchRaByRaIdCode,
    fetchSearchRaByPlate,
    checkOutInDownloadPdf,
    findCustomerBaseByUniqueData,
    checkSubstitutionCheckIn,
    recoveryCheckInUploadDoc,
    uploadVehicleAdjustmentPics,
    fetchRaUpdateCheckInOut,
}